import { Icon, IconButton } from '@ui'
import css from './index.module.scss'
import { InputGroup } from '@blueprintjs/core'
import StaticFilters from './StaticFilters'
import { useState } from 'react'
import SafeDistancingFilter from './SafeDistancingFilter'
import { SAFEDISTANCING } from './viewFiltersCalculations'
import DynamicFilters from './DynamicFilters'
import { ViewFilterChild, IViewFiltersData } from '@api'
import { ItemsKeysArray } from 'components/AdminFloorPlan/hooks/useMapViewSettings'

const ViewFiltersDrawer = ({
  setShowViewFilters,
  viewFiltersData,
  mapViewSetting,
}: {
  setShowViewFilters: (showViewFilters: boolean) => void
  viewFiltersData: IViewFiltersData
  mapViewSetting: {
    mapViewSettings: any
    updateMapViewSettings: (key: string, value: string, itemsKeys: ItemsKeysArray) => void
  }
}) => {
  const [searchedFilters, setSearchedFilters] = useState('')
  const {
    viewFilters: { filters },
  } = viewFiltersData
  return (
    <div className={css.viewFilters}>
      <div className={css.header}>
        <h2>Customize map view</h2>
        <IconButton
          className={css.closeButton}
          round={false}
          minimal
          iconName="close"
          onClick={() => setShowViewFilters(false)}
        />
      </div>
      <div className={css.resetButtonWrapper}>
        <div className={css.appliedFilters}>{filters?.length} applied</div>
        <div className={css.resetButton}>
          <button>Reset all</button>
        </div>
      </div>
      <div className={css.inputSearch}>
        <InputGroup
          style={{ height: 48 }}
          className="bp4-fill"
          autoFocus
          leftIcon={
            <span>
              <Icon name="search" className={css.search_icon} />
            </span>
          }
          onChange={(e) => setSearchedFilters(e.target.value)}
          placeholder="Search..."
        />
      </div>
      <div className={css.filter_container}>
        <StaticFilters
          isFiltered={!!searchedFilters}
          filters={viewFiltersData.viewFilters.staticFilterIds.filter(
            ({ filterId }: ViewFilterChild) => filterId !== SAFEDISTANCING
          )}
          viewFiltersData={viewFiltersData}
          mapViewSetting={mapViewSetting}
        />

        <DynamicFilters
          isFiltered={!!searchedFilters}
          filters={viewFiltersData.viewFilters.dynamicFilterIds}
          viewFiltersData={viewFiltersData}
        />

        <SafeDistancingFilter
          isFiltered={!!searchedFilters}
          filters={viewFiltersData.viewFilters.staticFilterIds.filter(
            ({ filterId }: ViewFilterChild) => filterId === SAFEDISTANCING
          )}
          viewFiltersData={viewFiltersData}
        />
      </div>
    </div>
  )
}

export default ViewFiltersDrawer
